// PureAscend Theme JS

// Product image gallery switcher
document.querySelectorAll('.pa-product-page__image').forEach((img, i) => {
  if (i === 0) return;
  img.style.opacity = '0.6';
  img.style.cursor = 'pointer';
  img.addEventListener('click', () => {
    document.querySelectorAll('.pa-product-page__image').forEach(el => {
      el.style.opacity = '0.6';
    });
    img.style.opacity = '1';
  });
});

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(a => {
  a.addEventListener('click', e => {
    const target = document.querySelector(a.getAttribute('href'));
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});
